import React, { useEffect, useState } from "react";
import { useDocTitle } from "../../components/_common/DocTitle";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";

import axios from 'axios';
import APIs from "../../APIs";

const useStyles = makeStyles((theme) => ({
    bigTitle: {
        margin: theme.spacing(0, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.125rem',
            fontWeight: theme.typography.fontWeightMedium
        },
    },
}))

const RSICECHY_InfoPage = props => {
    const classes = useStyles();
    const { t } = useTranslation();
    useDocTitle(t('pages.features'));

    const [data, setData] = useState([]);

    useEffect(() => {
        data.length ||
            axios
                .get(APIs.dataURL.rsicechy)
                .then(result => {
                    const apiData = result.data.results//.map(item => ({ ...item, nazwa_systemu: item.nazwa_systemu.replace(/(<([^>]+)>)|\t|\n/gi, "") }));

                    setData(apiData)
                })
    }, [data.length])

    const [isMobile, setIsMobile] = useState(window.innerWidth < 599.95);
    useEffect(() => {
        window.addEventListener('resize', () => {
            setIsMobile(window.innerWidth < 599.96)
        });
    }, [isMobile])

    return (
        <>
            <Typography variant="h4" className={classes.bigTitle} color="primary">{t('pages.features')}</Typography>
            <Typography variant="h4" className={classes.bigTitle} color="primary">{t('pages.infopage')} {props.match.params.id}</Typography>
        </>
    )
}

export default RSICECHY_InfoPage
